import types from './types'

export const setStatus = (status) => ({ type: types.DIRTY_SET_STATUS, status })
export const setSaveAction = (saveAction) => ({ type: types.DIRTY_SET_SAVE_ACTION, saveAction })
export const showPrompt = () => ({ type: types.DIRTY_SHOW_PROMPT })
export const hidePrompt = () => ({ type: types.DIRTY_HIDE_PROMPT })
export const setTargetRoute = (targetRoute) => ({ type: types.DIRTY_SET_TARGET_ROUTE, targetRoute })
export const changeRouteDirty = () => ({ type: types.DIRTY_CHANGE_ROUTE })
export const isFormValid = (isFormValid) => ({ type: types.DIRTY_SET_FORM_VALID, isFormValid })
export const setFormToInvalid = () => ({ type: types.DIRTY_FORM_IS_INVALID })

export default {
  setStatus,
  setSaveAction,
  showPrompt,
  hidePrompt,
  setTargetRoute,
  changeRouteDirty,
  isFormValid,
  setFormToInvalid,
}